import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import branch from 'client/core/branch';

@withRouter
@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrTourListRowConfirmRemoveModal extends Component {
  static propTypes = {
    tourId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    userAgent: PropTypes.object.isRequired,
  };

  _onCancelTour = () => {
    const { history, tourId } = this.props;
    history.push(`/tour/${tourId}/cancel`);
  };

  render() {
    const { isOpen, onClose, userAgent } = this.props;

    if (!isOpen) {
      return null;
    }

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose}
          className={classnames('darkModal', 'darkNavigator', { webview: isMobileApp })}
        >
          <div className="choiceContainer">
            <div className="choiceGroup">
              <div className="topLabel">
                <span>Are you sure you want to cancel?</span>
              </div>

              <div className="choice red" onClick={this._onCancelTour}>
                <span>Yes</span>
              </div>
            </div>

            <div className="choice solo" onClick={onClose}>
              <span>No</span>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrTourListRowConfirmRemoveModal.displayName = 'SrTourListRowConfirmRemoveModal';

export default SrTourListRowConfirmRemoveModal;
